import React, { useEffect, useState } from "react";
import styles from "../../CandidateDemo/AddCandidate/SubmitPage.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import { Box, useMediaQuery, useTheme } from "@mui/system";
import {
  calculateFieldCompletion,
  customTextColor,
  splitIntoColumns,
} from "../../../utils/const";
import { allSkill } from "../../../redux/common/skillSlice";
import { allLocation } from "../../../redux/common/locationSlice";
import { allWorkAuthorization } from "../../../redux/common/workAuthorizationSlice";
import { getProfile } from "../../../redux/profile/profileSlice";
import { useLocation, useNavigate } from "react-router-dom";
import {
  createCandidatetracker,
  getTrackerDetails,
  updateCandidatetracker,
} from "../../../redux/internal-tracking/InternalTrackerSlice";

const InternalCandidateSubmit = ({ setMenuName, setMenuId }) => {
  const [open, setOpen] = useState(false);
  const [isPrivate, setIsPrivate] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { row } = location?.state || {};
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const personalDetails = useSelector(
    (state) => state.internalCandidateStaticValue.data
  );
  const skillsExperience = useSelector(
    (state) => state.internalCandidateStaticValue.peviousExperienceData
  );
  const officialReference = useSelector(
    (state) => state.internalCandidateStaticValue.officialReferenceData
  );
  const workautho = useSelector((state) => state.workautho);
  const locations = useSelector((state) => state.location) || [];
  const skillData = useSelector((state) => state.skill.data);
  const trackerStatus = useSelector((state) => state.tracker.status);
  const profile = useSelector((state) => state.profile.data);

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalTrackerCandidateAddOrUpdate"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "internalTrackerCandidateAddOrUpdate",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);

  useEffect(() => {
    dispatch(allSkill());
    dispatch(allLocation());
    dispatch(allWorkAuthorization());
  }, []);

  const matchingSkills = skillData?.locations?.filter((skill) =>
    skillsExperience?.skills?.includes(skill.id)
  );
  const columns = splitIntoColumns(matchingSkills, 4);

  const matchingSkills2 = skillData?.locations?.filter((skill) =>
    skillsExperience?.secondary_skills?.includes(skill.id)
  );
  const columns2 = splitIntoColumns(matchingSkills2, 4);

  const handleOnClickEdit = () => {
    setMenuName("Persional Details");
    setMenuId(0);
  };

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  let userData = {
    email: personalDetails?.email,
    mobile_no: personalDetails?.mobile_no,
    full_name: personalDetails?.full_name,
    // gender: personalDetails?.gender,
    current_job_title: personalDetails?.current_job_title,
    total_experience: personalDetails?.total_experience,
    current_location: personalDetails?.current_location,
    // prefer_location: [1, 2],
    prefer_location: personalDetails?.prefer_location,
    work_preference: personalDetails?.work_preference,
    alternative_mobile_no: personalDetails?.alternative_mobile_no,
    work_authorization: personalDetails?.work_authorization,
    prefer_tax_team: "full_Time",
    p_tax_team: personalDetails?.prefer_tax_team,
    rate: personalDetails?.rate,
    linkedin_profile_url: personalDetails?.linkedin_profile_url,
    resume: personalDetails?.resume,
    current_company: personalDetails?.current_company,
    domain_name: personalDetails?.domain_name,
    highest_qualification: personalDetails?.highest_qualification,
    university: personalDetails?.university,
    // passing_year: formik2?.passing_year,
    // time_zone: formik2?.time_zone,
    previous_experience: JSON.stringify(skillsExperience?.previous_experience),
    skills: skillsExperience.skills,
    secondary_skills: skillsExperience.secondary_skills,
    employer_company_name: officialReference?.employer_company_name,
    employer_manager_name: officialReference?.employer_manager_name,
    employer_mobile_no: officialReference?.employer_mobile_no,
    employer_email: officialReference?.employer_email,
    referrer_company_name: officialReference?.referrer_company_name,
    referrer_manager_name: officialReference?.referrer_manager_name,
    referrer_mobile_no: officialReference?.referrer_mobile_no,
    referrer_email: officialReference?.referrer_email,
    // private: officialReference?.isPrivate == "private" ? true : false,
    status: isPrivate,
    profile_created_by: profile?.profile?.full_name,
    // empty_percentage: completionData?.emptyPercentage,
    // filled_percentage: completionData?.filledPercentage,
  };

  const completionData = calculateFieldCompletion(
    userData,
    personalDetails?.prefer_tax_team
  );

  const handelOnClickSubmit = () => {
    handleClickOpen(true);
  };

  const handleOnSubmitTracker = () => {
    // let id = row?.id;
    // if (row !== undefined) {
    //   dispatch(updateExistCandidateProfile({ userData, id }));
    // } else {
    let id = data?.row?.id;
    const updatedValues = {
      ...userData,
      empty_percentage: Number(completionData?.emptyPercentage),
      filled_percentage: Number(completionData?.filledPercentage),
    };
    if (data?.row !== undefined) {
      dispatch(updateCandidatetracker({ updatedValues, id }));
    } else {
      dispatch(createCandidatetracker(updatedValues));
    }
    // }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (data !== undefined) {
      if (data?.row?.internal) {
        // setIsPrivate("internal");
        setIsPrivate(1);
      } else if (data?.row?.private) {
        // setIsPrivate("private");
        setIsPrivate(2);
      }
    }
  }, [data]);

  useEffect(() => {
    if (
      trackerStatus === "create_candidate_intenal_succeeded" ||
      trackerStatus === "update_candidate_intenal_succeeded"
    ) {
      //   handleClose();
      let queryString = `page=1&page_size=10`;
      dispatch(getTrackerDetails(queryString));
      navigate("/internal-tracker");
    }
  }, [trackerStatus]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  const getWorkAuthorization = (id) => {
    let authorizationResult = workautho?.data?.work_authorization_data?.find(
      (res) => res.id === id
    );
    return authorizationResult?.name;
  };
  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  return (
    <div className={styles.container}>
      {/* Personal Details Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle} style={{ marginBottom: "20px" }}>
          Candidate Details
        </h2>
        <Grid container>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <ul
              style={{
                listStyleType: "square",
                padding: "5px 20px",
                marginBottom: "10px",
              }}
            >
              <li>
                <p>
                  <strong>Name:</strong> {personalDetails.full_name}
                </p>
              </li>

              <li>
                <p>
                  <strong>Experience:</strong>{" "}
                  {personalDetails.total_experience} years
                </p>
              </li>

              <li>
                <p>
                  <strong>E-Mail ID:</strong> {personalDetails.email}
                </p>
              </li>

              <li>
                <p>
                  <strong>Alternative Mobile:</strong>{" "}
                  {personalDetails.alternative_mobile_no}
                </p>
              </li>

              <li>
                <p>
                  <strong>Curent Location:</strong>{" "}
                  {getLocationById(personalDetails.current_location)}
                </p>
              </li>

              <li>
                <p>
                  <strong>Mode of Hiring::</strong>{" "}
                  {personalDetails.prefer_tax_team}
                </p>
              </li>

              <li>
                <p>
                  <strong>Work Preference:</strong>{" "}
                  {personalDetails.work_preference}
                </p>
              </li>

              <li>
                <p>
                  <strong>University:</strong> {personalDetails.university}
                </p>
              </li>

              {/* <li>
                <p>
                  <strong>Profile Type:</strong> {personalDetails.isPrivate}
                </p>
              </li> */}
            </ul>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <ul
              style={{
                listStyleType: "square",
                padding: "5px 20px",
                marginBottom: "10px",
              }}
            >
              <li>
                <p>
                  <strong>Job Profile:</strong>{" "}
                  {personalDetails.current_job_title}
                </p>
              </li>

              <li>
                <p>
                  <strong>Phone No:</strong> {personalDetails.mobile_no}
                </p>
              </li>

              <li>
                <p>
                  <strong>Preferred Location:</strong>{" "}
                  {getPreferLocationNames(personalDetails.prefer_location)}
                </p>
              </li>

              <li>
                <p>
                  <strong>Passing Year:</strong> {personalDetails.passing_year}
                </p>
              </li>

              <li>
                <p>
                  <strong>Rate:</strong> {personalDetails.rate}
                </p>
              </li>

              <li>
                <p>
                  <strong>Highest Qualification:</strong>{" "}
                  {personalDetails.highest_qualification}
                </p>
              </li>

              <li>
                <p>
                  <strong>Linkedin ID:</strong>{" "}
                  {personalDetails.linkedin_profile_url}
                </p>
              </li>

              <li>
                <p>
                  <strong>Work Authorization:</strong>{" "}
                  {getWorkAuthorization(personalDetails.work_authorization)}
                </p>
              </li>
            </ul>
          </Grid>
        </Grid>
      </section>

      {/* Skills and Experience Section */}
      <section className={styles.section}>
        {/* <h2 className={styles.sectionTitle}>Skills and Experience</h2> */}

        <Grid container sx={{ backgroundColor: "#fff" }}>
          <Grid item xs={12}>
            <Box className={styles.list_details}>
              <Typography sx={{ marginBottom: "20px !important" }}>
                <b>Primary skills</b>
              </Typography>
              <Grid container sx={{ fontWeight: "600" }}>
                {columns.map((column, colIndex) => (
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    lg={3}
                    key={colIndex}
                    sx={{
                      borderLeft: colIndex !== 0 ? "2px solid white" : "none",
                      paddingLeft: colIndex !== 0 ? "20px" : "0",
                    }}
                  >
                    <Box sx={{ color: customTextColor }}>
                      {column.map((skill) => (
                        <Typography
                          key={skill.id}
                          sx={{ marginBottom: "0 !important" }}
                        >
                          {skill.name}
                        </Typography>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </section>
      <section className={styles.section}>
        <Grid container sx={{ backgroundColor: "#fff", margin: "14px 0" }}>
          <Grid item xs={12}>
            <Box className={styles.list_details}>
              <Typography sx={{ marginBottom: "20px !important" }}>
                <b>Secondary skills</b>
              </Typography>
              <Grid container sx={{ fontWeight: "600" }}>
                {columns2.map((column, colIndex) => (
                  <Grid
                    item
                    xs={6}
                    sm={6}
                    md={3}
                    lg={3}
                    key={colIndex}
                    sx={{
                      borderLeft: colIndex !== 0 ? "2px solid white" : "none",
                      paddingLeft: colIndex !== 0 ? "20px" : "0",
                    }}
                  >
                    <Box sx={{ color: customTextColor }}>
                      {column.map((skill) => (
                        <Typography
                          key={skill.id}
                          sx={{ marginBottom: "0 !important" }}
                        >
                          {skill.name}
                        </Typography>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </section>
      <section className={styles.section}>
        {skillsExperience?.previous_experience ? (
          skillsExperience?.previous_experience?.map((prevData, index) => {
            return (
              <Box className={styles.full_details} key={index}>
                <Box sx={{ marginLeft: "20px" }}>
                  <Typography>
                    <b>{prevData?.role}</b>
                  </Typography>
                  <Typography>{prevData?.company}</Typography>
                  <Typography>{prevData?.industry_of_the_company}</Typography>
                  <Typography
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                      position: "relative",
                      bottom: "60px",
                      marginTop: "10px",
                    }}
                  >
                    {prevData?.duration_from} to {prevData?.duration_to}
                  </Typography>
                </Box>
                <ul>
                  {prevData?.summary_of_work?.map((text, index) => (
                    <li key={index}>{text}</li>
                  ))}
                </ul>
              </Box>
            );
          })
        ) : (
          <p>No Experience Found</p>
        )}
      </section>

      {/* Official Reference Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Official Reference</h2>
        <div className={styles.detailsGrid}>
          <p>
            <strong>Referrer Company:</strong>{" "}
            {officialReference.referrer_company_name}
          </p>
          <p>
            <strong>Referrer Manager:</strong>{" "}
            {officialReference.referrer_manager_name}
          </p>
          <p>
            <strong>Referrer Email:</strong> {officialReference.referrer_email}
          </p>
          <p>
            <strong>Referrer Mobile:</strong>{" "}
            {officialReference.referrer_mobile_no}
          </p>
        </div>
      </section>

      {personalDetails?.prefer_tax_team?.includes("full_Time") ? (
        ""
      ) : (
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Employer Details</h2>
          <div className={styles.detailsGrid}>
            <p>
              <strong>Employer Name:</strong>{" "}
              {officialReference.employer_manager_name}
            </p>
            <p>
              <strong>Employer Company:</strong>{" "}
              {officialReference.employer_company_name}
            </p>
            <p>
              <strong>Employer Email:</strong>{" "}
              {officialReference.employer_email}
            </p>
            <p>
              <strong>Employer Mobile:</strong>{" "}
              {officialReference.employer_mobile_no}
            </p>
          </div>
        </section>
      )}

      <div className={styles.submitButton}>
        <button
          style={{ backgroundColor: "#3e83eb", padding: "10px 28px" }}
          onClick={handleOnClickEdit}
          disabled={trackerStatus === "loading"}
        >
          Edit
        </button>
        <button
          disabled={trackerStatus === "loading"}
          onClick={handelOnClickSubmit}
        >
          {trackerStatus === "loading" ? "Loading" : "Submit"}
        </button>
      </div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth={true}
      >
        <Box sx={{ margin: "18px 15px", padding: "0 15px 0 15px" }}>
          <Typography>
            <b>Hi, {profile?.profile?.full_name}</b>
          </Typography>
          <Typography>
            You have successfully completed {completionData?.filledPercentage}
            {"%"} profile tracking for better in search result
          </Typography>
          {completionData?.emptyPercentage > 0 && (
            <Typography>
              please complete remain {completionData?.emptyPercentage}
              {"%"}
              .   
              <b
                style={{
                  color: "#3856a6",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Complete now
              </b>
            </Typography>
          )}
        </Box>

        <DialogContent sx={{ padding: "0 20px" }}>
          <Box className={styles.recruiter_matches_section}>
            <Box style={{ color: customTextColor }}>
              <Typography>
                <b>{personalDetails?.full_name}</b>
              </Typography>
              <Typography>
                {personalDetails?.current_job_title},{" "}
                {personalDetails?.total_experience} Years of Experience
              </Typography>
              <Typography>
                {getLocationById(personalDetails?.current_location)}
              </Typography>
            </Box>
            <span>
              <Typography
                sx={{
                  fontSize: "50px !important",
                  color: "#00a349",
                  position: "relative",
                  top: "10px",
                }}
              >
                <b>
                  {completionData?.filledPercentage}
                  {"%"}
                </b>
              </Typography>

              <b>Profile Completed</b>
            </span>
            {/* <img src={image} alt="" /> */}
          </Box>
          <hr></hr>
          <Box className={styles.consultant_listing_text}>
            <Box>
              <Typography sx={{ marginLeft: "10px" }}>
                <b>Who can view this consult profile?</b>
              </Typography>
              <Typography>
                <input
                  type="radio"
                  id="private"
                  name="private"
                  checked={isPrivate === 1}
                  onChange={() => setIsPrivate(1)}
                />
                <label htmlFor="private" style={{ marginLeft: "10px" }}>
                  Private (only you can view)
                </label>
                <br />
              </Typography>
              <Typography>
                <input
                  type="radio"
                  id="internal"
                  name="private"
                  checked={isPrivate === 2}
                  onChange={() => setIsPrivate(2)}
                />
                <label htmlFor="internal" style={{ marginLeft: "10px" }}>
                  Internal Employees Access
                </label>
                <br />
              </Typography>

              {/* <Typography>
                <input
                  type="radio"
                  id="community"
                  name="private"
                  checked={isPrivate === 3}
                  onChange={() => setIsPrivate(3)}
                />
                <label for="internal" style={{ marginLeft: "10px" }}>
                  Community Employees Access <b>(recommended)</b>
                </label>
              </Typography> */}

              {isPrivate === "private" && (
                <Typography sx={{ marginTop: "10px" }}>
                  <b>Note</b> : You might be losing some other colleagues
                  profiles until this profile is not converted into internal
                  employee access.
                </Typography>
              )}
              <Typography sx={{ marginTop: "10px" }}>
                <b>Note</b> : If you add one unique candidate you can access 100
                candidates in community candidates
              </Typography>
            </Box>
            <button
              style={
                trackerStatus === "loading"
                  ? {
                      padding: "4px 25px",
                      backgroundColor: "#3856a6 ",
                      alignSelf: "flex-end",
                    }
                  : {
                      backgroundColor: "#3856a6 ",
                      padding: "7.5px 12px ",
                      alignSelf: "flex-end",
                    }
              }
              onClick={handleOnSubmitTracker}
              disabled={!isPrivate}
            >
              {trackerStatus === "loading" ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "Confirm"
              )}
            </button>
          </Box>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
};

export default InternalCandidateSubmit;
